module.exports = __webpack_public_path__ + "static/media/pallet-home-image.baa6ee2c.jpg";